import axios from './axios';

export const searchPupils = (filter, selectedPupilsIds, pageSize) =>
  axios.post('/pupils/search', {
    excludedIds: selectedPupilsIds,
    filter,
    pagination: {
      pageNumber: 1,
      size: pageSize,
      sort: [
        {
          direction: 'ASC',
          property: 'surname',
        },
      ],
    },
  });

/**
 * @api get transportation/pupils/${studentId}/delivery/location
 * Get pupil location with location information about transportation.
 * @param {sting} studentId StudentId
 * @return {Promise}
 * */
export const getPupilsDeliveryLocation = studentId =>
  axios.get(`transportation/pupils/${studentId}/delivery/location`);

export const uploadPupilAvatar = ({ pupilId, file }) =>
  axios.post(`pupils/${pupilId}/avatar`, file);
